import { Capacitor } from '@capacitor/core'
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera'

function userDismissed(err) {
  const s = String(err?.message ?? err ?? '').toLowerCase()
  return (
    s.includes('cancel') ||
    s.includes('dismiss') ||
    s.includes('user denied') ||
    s.includes('no image') ||
    s.includes('did not select')
  )
}

/**
 * צילום בלבד (מצלמה). לא גלריה — getPhoto מ-Photos דוחס מחדש ל-JPEG ומשנה קבצים מהגלריה.
 *
 * @returns {Promise<{ status: 'ok', dataUrl: string } | { status: 'web' } | { status: 'cancel' } | { status: 'fallback' }>}
 */
export async function pickFromCameraOnly() {
  if (!Capacitor.isNativePlatform()) return { status: 'web' }
  try {
    const photo = await Camera.getPhoto({
      quality: 90,
      allowEditing: false,
      resultType: CameraResultType.DataUrl,
      source: CameraSource.Camera,
      correctOrientation: true,
    })
    if (photo.dataUrl) return { status: 'ok', dataUrl: photo.dataUrl }
    return { status: 'cancel' }
  } catch (e) {
    if (userDismissed(e)) return { status: 'cancel' }
    return { status: 'fallback' }
  }
}
